/**
 * @flow
 */

import styled from 'react-emotion'

import { mobile, customDevice } from '../../../utils/mixins'
import {
  Typo24PumpkinOrangeDDI,
  Typo16WhiteDR
} from '../../../themes/Fonts/Din2014'
import Colors from '../../../themes/Colors'
import { Typo36WhiteTwoBN9I } from '../../../themes/Fonts/Nort'

export const LandingSectionContainer = styled('section')`
  z-index: 10;
  background-image: url(${props => props.desktopBackgroundImage}),
    linear-gradient(114deg, ${Colors.black}, rgba(18, 18, 18, 0));
  background-size: cover;
  background-repeat: no-repeat;

  padding-top: 130px;
  background-position-x: 50%;
  background-position-y: bottom;
  ${mobile} {
    background-image: url(${props => props.mobileBackgroundImage}),
      linear-gradient(to bottom, ${Colors.black}, rgba(18, 18, 18, 0));
    min-height: 100vh;
  }
  ${customDevice(768, 1024)} {
    min-height: 471px;
  }
  position: relative;
`
export const ButtonContainer = styled('div')`
  background-color: ${Colors.pumpkinOrange};
  padding-top: 7px;
  padding-bottom: 7px;
  padding-left: 20px;
  padding-right: 20px;
  cursor: pointer;
  :hover {
    text-decoration: none;
  }
  :focus {
    text-decoration: none;
  }
  ${mobile} {
    padding-left: 11px;
    padding-right: 11px;
  }
`
export const SectionWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin-top: 119px;
  width: 87%;
  margin-bottom: 155px;
  ${mobile} {
    width: 100%;
    margin-top: 55px;
    margin-bottom: 60px;
  }
  ${customDevice(768, 899)} {
    width: 100%;
  }
  ${customDevice(900, 1024)} {
    width: 70.5%;
  }
`
export const Heading = styled(Typo36WhiteTwoBN9I)`
  line-height: 1.36;
  letter-spacing: 1px;
  margin-top: 0px;
  margin-bottom: 20px;
  ${mobile} {
    font-size: 24px;
    line-height: 1.25;
    margin-bottom: 30px;
  }
  ${customDevice(768, 1024)} {
    font-size: 30px;
    line-height: normal;
  }
`

export const HeadingDescription = styled(Typo24PumpkinOrangeDDI)`
  letter-spacing: 0.5px;
  padding-bottom: 10px;
  text-shadow: 0 4px 8px ${Colors.black10};
  ${mobile} {
    font-size: 20px;
  }
`

export const ButtonDescription = styled(Typo16WhiteDR)`
  letter-spacing: 1px;
  pointer-events: none;
  ${mobile} {
    font-size: 12px;
    letter-spacing: 0.5px;
  }
`



// WEBPACK FOOTER //
// ./src/components/Events/LandingPage/styledComponents.js